import { mediaBoxApi } from '@/axios/mediaBox';
import type { SelectProps } from 'antd';
import type { ReactNode } from 'react';
import PaginationSelector from './PaginationSelector';

type Params = Omit<Parameters<typeof mediaBoxApi.list>[0], 'pageIndex' | 'pageSize'>;

// 提取 records 数组元素的类型
type TaskRecord = Awaited<ReturnType<typeof mediaBoxApi.list>>['records'][number];

interface BaseProps {
  params?: Params;
  placeholder?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  popupMatchSelectWidth?: SelectProps['popupMatchSelectWidth'];
  classNames?: SelectProps['classNames'];
  placement?: SelectProps['placement'];
  listHeight?: SelectProps['listHeight'];
  endReachedContent?: ReactNode;
  /** 默认选项列表，用于在第一页找不到数据时的回显 */
  defaultOptions?: Array<{ label: string; value: string }>;
}

interface SingleProps extends BaseProps {
  value?: string;
  onChange?: (value: string) => void;
  multiple?: false;
}

interface MultipleProps extends BaseProps {
  value?: string[];
  onChange?: (value: string[]) => void;
  multiple: true;
}

export type MediaBoxSelectorProps = SingleProps | MultipleProps;

const formatMediaLabel = (item: TaskRecord) => {
  const details = [item.price != null ? `￥${item.price}` : undefined, item.channelType, item.displayChannel].filter(
    (detail) => detail !== undefined && detail !== null && detail !== ''
  );

  return `${item.mediaName}${details.map((detail) => `(${detail})`).join('')}`;
};

/** 用户选择器 */
const MediaBoxSelector = (props: MediaBoxSelectorProps) => {
  const {
    params,
    placeholder = '请选择媒介类型',
    value,
    onChange,
    multiple = false,
    defaultOptions,
    style,
    disabled,
    popupMatchSelectWidth,
    classNames,
    placement,
    listHeight,
    endReachedContent,
  } = props;

  return (
    <PaginationSelector<TaskRecord, Params>
      fetchApi={(params) => mediaBoxApi.list(params)}
      params={params}
      optionTransform={(item) => ({
        value: item.id,
        label: formatMediaLabel(item),
      })}
      searchParamKey="mediaName"
      placeholder={placeholder}
      value={value}
      onChange={onChange as any}
      multiple={multiple}
      defaultOptions={defaultOptions}
      style={style}
      disabled={disabled}
      popupMatchSelectWidth={popupMatchSelectWidth}
      classNames={classNames}
      placement={placement}
      listHeight={listHeight}
      endReachedContent={endReachedContent}
    />
  );
};
export default MediaBoxSelector;
